import script from "./ValueList.vue?vue&type=script&setup=true&lang=js"
export * from "./ValueList.vue?vue&type=script&setup=true&lang=js"

import "./ValueList.vue?vue&type=style&index=0&id=c9acad86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9acad86"]])

export default __exports__